

import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";

const Mytheme = definePreset(Aura, {
    primitive:{

        borderRadius:{
            none:0,
            xs:"2px",
            sm:"4px",
            md:"6px",
            lg:"8px",
            xl:"999px"
        },



    },
    semantic: {

        primary: {
            50: "#eff6ff",
            100: "#dbeafe",
            200: "#bfdbfe",
            300: "#93c5fd",
            400: "#60a5fa",
            500: "#3b82f6",
            600: "#2563eb",
            700: "#1d4ed8",
            800: "#1e40af",
            900: "#1e3a8a",
            950: "#172554"


        },
        formField: {
            paddingX: "11px",
            paddingY: "6px",
            borderRadius: "6px",
            sm: {
                fontSize: "14px", paddingX: "11px",
                paddingY: "6px",

            }
        },
        colorScheme:{
           light:{

           },
           dark:{
             neutral:{            
            100: "#171717",
            200: "#404040",
            300: "#404040",
            400: "#737373",
            500: "#cbd5e1",
            900: "#cbd5e1",
            },
            slate:{
             50: "#020617",
            100: "#0f172a",
            200: "#1e293b",
            300: "#334155",
            400: "#475569",
            500: "#64748b",
            600: "#cbd5e1",
            700: "#cbd5e1",
            800: "#e2e8f0",
            900: "#f1f5f9",
            950: "#f8fafc"
            },           
gray: {
            50: "#030712",
            100: "#464646",
            200: "#666666",
            300: "#374151",
            400: "#ababab",
            500: "#6b7280",
            600: "#9ca3af",
            700: "#d1d5db",
            800: "#e5e7eb",
            900: "#f3f4f6",
            950: "#f9fafb"
        },
          primary: {
              50: "#172554",
            100: "#1e3a8a",
            200: "#1e40af",
            300: "#1d4ed8",
            400: "#2563eb",
            500: "#3b82f6",
            600: "#60a5fa",
            700: "#93c5fd",
            800: "#bfdbfe",
            900: "#dbeafe",
            950: "#eff6ff"
          },
          
zinc: {
            50: "#09090b",
            100: "#55555d",
            200: "#27272a",
            300: "#3f3f46",
            400: "#52525b",
            500: "#71717a",
            600: "#a1a1aa",
            700: "#d4d4d8",
            800: "#e4e4e7",
            900: "#f4f4f5",
            950: "#fafafa"
        },
        surface: {
                    0: "#020617",
                    50: "#0f172a",
                    100: "#1e293b",
                    200: "#334155",
                    300: "#475569",
                    400: "#64748b",
                    500: "#94a3b8",
                    600: "#cbd5e1",
                    700: "#e2e8f0",
                    800: "#f1f5f9",
                    900: "#f8fafc",
                    950: "#ffffff"
                }
           }
        }
    },


    components: {
        megamenu:{
            colorScheme:{
                light:{
                    root:{
                        background:'transperent',
                        borderColor:"transperent",
                        borderRadius:'0px',
                        verticalOrientation:{
                            gap:"28px",
                            padding:'0px'
                        }

                    },
                    item:{
                        focusBackground:'transperent',
                        borderRadius:'0px',
                        focusColor:"#fff",
                        activeBackground:'transperent',
                        activeColor:'#fff'

                    },
                    overlay:{
                        background:"#334155",
                        borderRadius:"6px",
                        color:"#fff"
                    },
                    separator:{
                        borderColor:'#314257'
                    }

                },
                dark:{
                    root:{
                        background:'transparent',
                        borderColor:'transparent',
                        borderRadius:'0px',
                        verticalOrientation:{
                            gap:"28px",
                            padding:'0px'
                        }
                    },
                    item:{
                        focusBackground:'transparent',
                        borderRadius:'0px',
                        focusColor:'{surface.0}',
                        activeBackground:'transparent',
                        activeColor:'{surface.0}'
                    },
                    overlay:{
                        background:'{surface.800}',
                        borderRadius:'6px',
                        color:'{surface.0}'
                    },
                    separator:{
                        borderColor:'{surface.700}'
                    }
                }
            }
        },
        scrollpanel:{
            bar:{
                size:"4px"
            },

            colorScheme:{
                light:{
                    bar:{
                        background:"{surface.500}"
                    }
                },
                dark:{
                    bar:{
                        background:"{surface.500}"
                    }
                }
            }
        },
        menu: {
            colorScheme: {
                light: {
                    root: {
                        background: '#fff',
                        borderColor: "#e2e8f0",

                        color: "#000",
                        borderRadius:'8px',
                        shadow:'0 6px 16px 0  rgba(0, 0, 0, 0.10), 0 3px 6px -4px rgba(0, 0, 0, 0.15), 0 9px 28px 8px  rgba(0, 0, 0, 0.10)'


                    },
                    list: { padding: "8px 8px", gap: "8px" },
                    item: {
                        focusBackground: "{primary.600}",
                        focusColor: "#fff",
                        color: "{--p-slate-900}",
                        padding: "8px 8x",
                        borderRadius: "4px",
                        gap: "8px"
                    },
                    submenuLabel: {
                        padding: "8px 0px;"
                    }
                },
                dark: {
                    root: {
                        background: '{surface.50}',
                        borderColor: '{surface.200}',
                        color: '{surface.900}',
                        borderRadius: '8px',
                        shadow: '0 6px 16px 0 rgba(0, 0, 0, 0.40), 0 3px 6px -4px rgba(0, 0, 0, 0.50), 0 9px 28px 8px rgba(0, 0, 0, 0.40)'
                    },
                    list: { padding: "8px 8px", gap: "8px" },
                    item: {
                        focusBackground: "{primary.500}",
                        focusColor: "#fff",
                        color: "{surface.900}",
                        padding: "8px 8x",
                        borderRadius: "4px",
                        gap: "8px"
                    },
                    submenuLabel: {
                        padding: "8px 0px;"
                    }
                }
            }
        },
       toggleswitch:{
        root:{
            width:'32px',
            height:"18px"
        },
        handle:{
            size:"12px"
        },
        colorScheme:{
            light:{
                root:{
                    background:"{gray.400}",
                    hoverBackground:"{gray.400}",
                    checkedBackground:"{primary.600}",
                     checkedHoverBackground:"{primary.600}"
                }
            },
            dark:{
                root:{
                    background:"{surface.600}",
                    hoverBackground:"{surface.500}",
                    checkedBackground:"{primary.500}",
                    checkedHoverBackground:"{primary.500}"
                }
            }
        }

       },
       drawer:{
        root:{
        
        },
        header:{
           padding:'16px 24px 16px 24px',
          
        },
        content:{
           padding:"24px 24px 24px 24px",

        },
        colorScheme:{
            light:{
                root:{
                    color:"{slate.900}",
                    background:"#fff",
                   
                }
            },
            dark:{
                root:{
                    color:"{surface.900}",
                    background:"{surface.50}",
                     borderColor:"{surface.100}"
                },
            }
        }
       },
        checkbox: {
            root: {
                width: "16px",
                height: "16px",
                borderColor: "{neutral-400}",
                borderRadius: "4px",
                checkedBackground:"{primary.600}",
                checkedHoverBackground:"{primary.600}",
                sm:{
                    width: "12px",
                    height: "12px",
                },
                lg:{
                    width: "16px",
                    height: "16px",
                }
            },
            icon: {
                size: "10px"
            },
            colorScheme:{
                dark:{
                    root:{
                        borderColor:"{surface.600}",
                        checkedBackground:"{primary.500}",
                        checkedHoverBackground:"{primary.500}"
                    }
                }
            }

        },
        tieredmenu:{
            colorScheme: {
                light: {
                    root: {
                        background: "transperent",

                        color: "#fff",
                        borderColor:"transperent",

                    },
                    item: {
                        color: '#fff',
                        focusBackground:'transperent',
                        activeBackground:'transperent',
                        activeColor:'transperent',

                    },
                    separator:{
                        borderColor:'#314257'
                    },
                    list:{
                        padding:"0px",
                    }
                },

                dark: {
                    root: {
                        background: "transparent",
                        color: "{surface.0}",
                        borderColor: "transparent",
                    },
                    item: {
                        color: '{surface.0}',
                        focusBackground:'transparent',
                        activeBackground:'transparent',
                        activeColor:'transparent',
                    },
                    separator:{
                        borderColor:'{surface.700}'
                    },
                    list:{
                        padding:"0px",
                    }
                }
            },
        },

        menubar: {
            colorScheme: {
                light: {
                    root: {
                        background: "transperent",

                        color: "#fff",
                        borderColor:"transperent"
                    },
                    item: {
                        color: '#fff',
                        focusBackground:'transperent',
                        activeBackground:'transperent',
                        activeColor:'transperent'
                    }
                },

                dark: {
                    root: {
                        background: "transparent",
                        color: "{surface.0}",
                        borderColor: "transparent"
                    },
                    item: {
                        color: '{surface.0}',
                        focusBackground:'transparent',
                        activeBackground:'transparent',
                        activeColor:'transparent'
                    }
                }
            },
        },
        paginator: {
            root: { borderRadius: "6px ", gap: "8px", padding: "13px 0px 13px 0px"},
            navButton: {
                hoverBackground: "{primary-600}",
                selectedBackground: "transparent",
                hoverColor: "{surface-50}",
                selectedColor: "{primary.600}",
                borderRadius: "6px",

                width: "24px",
                height: "24px"

            },
            colorScheme:{
                light:{
                    root:{ color:"{primary.600}" },
                    navButton:{
                        background:"#fff",
                        color:"{slate.900}"
                    },
                    currentPageReport:{
                        color:"{slate.900}"
                    }
                },
                dark:{
                    root:{ color:"{primary.400}" },
                    navButton:{
                        background:"{surface.900}",
                        color:"{surface.0}",
                        hoverBackground:"{primary.500}",
                        hoverColor:"{surface.0}",
                        selectedColor:"{primary.400}"
                    },
                    currentPageReport:{
                        color:"{surface.0}"
                    }
                }
            }
        },
        accordion: {
            header: {
                color: "{primary-500}",
                activeColor: "{primary-500}"
            }
        },
        inputgroup:{
              colorScheme:{
                light:{
                    addon:{
                        color:"{slate-900}"
                    }
                },
                dark:{
                    addon:{
                         color:"{slate-900}"
                    }
                }
              }
        },
        inputtext: {

            root: {
                borderColor: "{neutral-400}",
                hoverBorderColor: "{primary-600}",
                focusBorderColor: "{primary-600}",
                borderRadius:"6px",


                shadow: "none",
                // borderRadius:""
                sm:{
                    fontSize:"12px",
                     paddingY:"5px",
                    paddingX:"10px"
                },
                lg:{
                    fontSize:"14px",
                    paddingY:"6px",
                    paddingX:"10px"
                }
            },
            colorScheme:{
                light:{
                    root:{
                        color:"{slate.900}",
                        background:"#fff"
                    }
                },
                dark:{
                    root:{
                        color:"{slate.900}",
                        background:"{surface.50}",
                        borderColor:"{surface.50}",
                        hoverBorderColor:"{primary.400}",
                        focusBorderColor:"{primary.400}"
                    }
                }
            }
        },


        radiobutton:{
                   root:{
                     width:"16px",
                     height:"16px",
                     borderColor:"{neutral-400}",
                     checkedBackground:"{primary-600}",
                     checkedHoverBackground:"{primary-900}",
                     focusRing:{
                        width:"10px",

                     }
                   },
                   icon:{
                    size:"8px"
                   },
                   colorScheme:{
                     dark:{
                        root:{
                            borderColor:"{surface.50}",
                            checkedBackground:"{primary.500}",
                            checkedHoverBackground:"{primary.400}"
                        }
                     }
                   }

        },

        select: {

            root: {
                borderColor: "{neutral-400}",
                borderRadius:"6px",
                hoverBorderColor: "{primary-600}",
                focusBorderColor: "{primary-600}",
                paddingX:"12px",
                paddingY:'6px',
                shadow: "none",
            sm:{
                paddingX:"10px",
                paddingY:"5px",
                fontSize:'12px'
            },
            lg:{
                paddingX:"10px",
                paddingY:"6px",
                fontSize:'14px'
            },

            },
            dropdown:{
                width:"30px"
            },
            colorScheme:{
                light:{
                    root:{ color:"{neutral.900}", background:"#fff" }
                },
                dark:{
                    root:{
                        color:"{surface.800}",
                        background:"{surface.50}",
                        borderColor:"{surface.50}",
                        hoverBorderColor:"{primary.400}",
                        focusBorderColor:"{primary.400}"
                    },
                    overlay:{
                        background:"{surface.50}",
                        borderColor:"{surface.50}",
                        color:"{surface.800}"
                    },
                    option:{
                        color:"{surface.800}",
                        focusBackground:"{surface.800}",
                        focusColor:"{surface.300}",
                        selectedBackground:"{primary.500}",
                        selectedColor:"#fff"
                    },
                
                
                }
            }

        },
        multiselect:{
            root: {
                borderColor: "{neutral-400}",
                borderRadius:"6px",
                hoverBorderColor: "{primary-600}",
                focusBorderColor: "{primary-600}",
                paddingX:"12px",
                paddingY:'6px',
                shadow: "none",
            sm:{
                paddingX:"10px",
                paddingY:"5px",
                fontSize:'12px'
            },
            lg:{
                paddingX:"10px",
                paddingY:"6px",
                fontSize:'14px'
            },

            },
            dropdown:{
                width:"30px"
            },
            colorScheme:{
                light:{
                    root:{ color:"{neutral.900}", background:"#fff" }
                },
                dark:{
                    root:{
                        color:"{surface.0}",
                        background:"{surface.900}",
                        borderColor:"{surface.600}",
                        hoverBorderColor:"{primary.400}",
                        focusBorderColor:"{primary.400}"
                    },
                    overlay:{
                        background:"{surface.900}",
                        borderColor:"{surface.700}",
                        color:"{surface.0}"
                    },
                    option:{
                        color:"{surface.0}",
                        focusBackground:"{surface.800}",
                        focusColor:"{surface.0}",
                        selectedBackground:"{primary.500}",
                        selectedColor:"#fff"
                    }
                }
            }
        },

        datepicker:{
              panel:{
                padding:"5px",
              },
              date:{
                width:"22x",
                height:"22px",
                padding:"5px",
                borderRadius:"99px",
                hoverBackground:"{primary-600}",
                selectedBackground:"{primary-600}",
                hoverColor:"{gray-50}",
                selectedColor:"{gray-50}"


              },
              colorScheme:{
                light:{
                    panel:{
                        background:"#fff",
                        color:"{p-slate-900}",
                        borderColor:"{surface.200}"
                    },
                    inputIcon:{ color:"{slate.600}" }
                },
                dark:{
                    panel:{
                        background:"{surface.900}",
                        color:"{surface.0}",
                        borderColor:"{surface.700}"
                    },
                    date:{
                        color:"{surface.0}",
                        hoverBackground:"{primary.500}",
                        selectedBackground:"{primary.500}"
                    },
                    inputIcon:{ color:"{surface.300}" }
                }
              }
        },
        badge: {
            root: {

                fontSize: "10px",
                height:"16px",
                minWidth:"16px",
                fontWeight: "700"
            },
            colorScheme:{
                light:{
                    primary:{
                        background:"{primary-600}",
                        color:"#fff"
                    }
                },
                dark:{
                    primary:{
                        background:"{primary.500}",
                        color:"#fff"
                    }
                }
            }
        },

        textarea: {

            root: {
                borderColor: "{neutral-400}",
                hoverBorderColor: "{primary-600}",
                focusBorderColor: "{primary-color}",
                shadow: "none",
                sm:{
                    fontSize:"12px",
                    paddingX:"10px",
                    paddingY:"6px"
                },
                lg:{
                    fontSize:"14px",
                    paddingX:"10px",
                    paddingY:"6px"
                }
            },
            colorScheme:{
                light:{
                    root:{ color:"{neutral.900}", background:"#fff" }
                },
                dark:{
                    root:{
                        color:"{surface.900}",
                        background:"{surface.50}",
                        borderColor:"{surface.600}",
                        hoverBorderColor:"{primary.400}",
                        focusBorderColor:"{primary.400}"
                    }
                }
            }
        },
        tooltip:{
            root:{
                gutter:"6px",
                padding:'4px 12px',
                borderRadius:"4px",
                maxWidth:"300px",
                
                
            },
            colorScheme:{
                light:{
                    root:{ background:"{slate.800}", color:"#fff" }
                },
                dark:{
                    root:{ background:"{surface.700}", color:"{surface.0}" }
                }
            }

        },
        card: {
            root: {
                shadow: "0",
                borderRadius:"8px"
            },
            body: { padding: '0px', gap: '0' },
           colorScheme:{
            light:{
                root:{
                    background:"#ffffff",
                    color:"{slate.900}"
                }
            },
            dark:{
                root:{
                    background:"{surface.900}",
                    color:"{surface.0}"
                }
            }
           }
        },
        tag:{
          root:{
 padding:"5px 10px",
 borderRadius:"90px",
 fontSize:"12px",
 fontWeight:"400"
          },
          colorScheme:{
            light:{
                secondary:{
                    background:"{gray.200}",
                    color:"{slate.900}"

                }
            },
            dark:{
                secondary:{
                   background:"{gray.200}",
                   color:"{slate.900}"
                }
            }
          }
        },
        button: {
            colorScheme: {
                light: {
                    root: {
                        borderRadius:"4px",
                        raisedShadow:"0",
                        sm: { fontSize: "12px", paddingX: "10px", paddingY: "5px"},
                        lg: { fontSize: "14px", paddingX: "12px", paddingY: "5px"},
                        label: { fontWeight: "400" },
                        primary: {
                            background: "{primary-600}",
                            hoverBackground: "{primary-700}",
                            activeBackground: "{primary-700}",
                            borderColor: "{primary-600}",
                            hoverBorderColor: "{primary-700}",
                            activeBorderColor: "{primary-700}",
                            color: "#fff",
                            hoverColor: "#fff",
                            activeColor: "#fff",




                        },
                        secondary: {
                            background: "transparent",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"
                        },
                        success:{
                            background: "transparent",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"

                        },
                        info:{
                            background: "{gray.100}",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"

                        },
                        danger:{
                            background:"#fff",
                            borderColor: "{neutral-300}",
                            activeBackground: '{red-100}',

                            hoverBackground: '{red-100}',
                            hoverBorderColor  :'{red-500}',
                            hoverColor  :'{red-500}',
                            activeColor:'{red-500}',
                            color: '{red-500}',

                        }


                    },
                    link: {
                        color: "{primary-600}",
                        hoverColor: "{primary-600}",
                        activeColor: "{primary-600}"
                    },
                    outlined: {
                        primary: {
                            borderColor: '{primary-600}',

                            activeBackground: '#fff{primary-100}',
                            hoverBackground: '{primary-100}',

                            color: '{primary-600}',
                            //hoverColor:"#fff"

                        },
                        secondary: {
                            borderColor: "{neutral-300}",
                            activeBackground: '{neutral-100}',
                            hoverBackground: '{neutral-100}',
                            color: '{slate-900}',
                            //hoverColor:'#fff'
                        },



                    },
                    text:{
                        primary:{
                            hoverBackground:"transperent",
                            activeBackground:"transperent",
                            color:"{primary-600}"
                        },

                    }
                },
                dark: {
                    root: {
                        borderRadius:"4px",
                        raisedShadow:"0",
                        sm: { fontSize: "12px", paddingX: "10px", paddingY: "5px"},
                        lg: { fontSize: "14px", paddingX: "12px", paddingY: "5px"},
                        label: { fontWeight: "400" },
                        primary: {
                            background: "{primary-600}",
                            hoverBackground: "{primary-700}",
                            activeBackground: "{primary-700}",
                            borderColor: "{primary-600}",
                            hoverBorderColor: "{primary-700}",
                            activeBorderColor: "{primary-700}",
                             color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"




                        },
                        secondary: {
                            background: "transparent",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"
                        },
                        success:{
                            background: "transparent",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"

                        },
                        info:{
                            background: "{gray.100}",
                            hoverBackground: "{primary.100}",
                            activeBackground: "{primary.100}",
                            borderColor: "{neutral-300}",
                            hoverBorderColor: "{primary.600}",
                            activeBorderColor: "{primary.600}",
                            color: "{slate-900}",
                            hoverColor: "{primary.600}",
                            activeColor: "{primary.600}"

                        },
                        danger:{
                            background:"#fff",
                            borderColor: "{neutral-300}",
                            activeBackground: '{red-100}',

                            hoverBackground: '{red-100}',
                            hoverBorderColor  :'{red-500}',
                            hoverColor  :'{red-500}',
                            activeColor:'{red-500}',
                            color: '{red-500}',

                        }


                    },
                    link: {
                        color: "{primary-600}",
                        hoverColor: "{primary-600}",
                        activeColor: "{primary-600}"
                    },
                    outlined: {
                        primary: {
                            borderColor: '{primary-600}',

                            activeBackground: '#fff{primary-100}',
                            hoverBackground: '{primary-100}',

                            color: '{primary-600}',
                            //hoverColor:"#fff"

                        },
                        secondary: {
                            borderColor: "{neutral-300}",
                            activeBackground: '#434343',
                            hoverBackground: '#434343',
                            color: '{slate-900}',
                            
                            //hoverColor:'#fff'
                        },



                    },
                    text:{
                        primary:{
                            hoverBackground:"transperent",
                            activeBackground:"transperent",
                            color:"{primary-600}"
                        },

                    }
                }
            }
        },
        dialog:{
            root:{
                borderRadius:"8px"


            },
            header:{
               padding:"16px 24px 10px 24px"
            },
            title:{
                fontSize:"16px",
                fontWeight:"600",

            },  footer:{
                padding:"16px 24px 10px 24px"
                          },
            content:{
                padding:"16px 24px 16px 24px;"
            },
            colorScheme:{
                light:{
                    root:{
                        background:"#fff",
                        color:"{slate.900}",
                        borderColor:"{surface.200}"
                    }
                },
                dark:{
                    root:{
                        background:"{surface.50}",
                        color:"{surface.900}",
                        borderColor:"{surface.100}"
                    }
                }
            }
        },
        confirmpopup:{
            root:{
                borderRadius:"8px",
                gutter:"8px"
            },
            colorScheme:{
                dark:{
                    root:{
                        background:"{surface.50}",
                        color:"{surface.0}",
                        borderColor:"{surface.700}"
                    }
                }
            }

        },
        tabs:{
            root:{},
            tabpanel:{
                padding:"16px",
                color:"{primary-600}"
            },
            tab:{
                color:"{primary-600}"
            },
            activeBar:{
                height:"3px"
            },
            colorScheme:{
                dark:{
                    tabpanel:{ color:"{primary.400}" ,
                        background:"{surface.50}"
                    },
                    tab:{
                        color:"{surface.0}",
                        activeColor:"{primary.400}",
                        hoverColor:"{primary.400}"
                    }
                }
            }

        },
        inlinemessage:{
           colorScheme:{
            light:{
                success:{
                    background:"F6ffed",
                    borderColor:"#b7eb8f",
                    color:"rgba(0,0,0,.88)"

                }
            },
            dark:{
                success:{
                    background:"{green.950}",
                    borderColor:"{green.700}",
                    color:"{surface.0}"
                }
            }
           }

        },

        toast:{
            root:{
                width:"380px",
                borderRadius:"6px",
                borderWidth:"0px 0px 0px 3px"

            },

            summary:{
                fontSize:"16px",
                fontWeight:"400",


            },
            content:{
                padding:"15px 15px"

            },
            text:{
                gap:"8px"
            },
            detail:{
                fontSize:"14px",
                fontWeight:"400"
            },
            closeButton:{
                width:"18px",
                height:"18px"
            },
            closeIcon:{
                size:"10px",



            },
            colorScheme:{
                light:{
                    success:{
                        background:"#fff",
                        borderColor:"{green-500}",
                        color:"#262626",
                        detailColor:"#737373",
                        shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.16);"

                    },
                    error:{
                        background:"#fff",
                        borderColor:"#ef4444",
                        color:"#262626",
                        detailColor:"#737373" ,
                          shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.16);"
                    },
                    warn:{
                        background:"#fff",
                        borderColor:"#f97316",
                        color:"#262626",
                        detailColor:"#737373" ,
                          shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.16);"
                    },
                    info:{
                        background:"#fff",
                        borderColor:"#3b82f6",
                        color:"#262626",
                        detailColor:"#737373",
                          shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.16);"
                    }

                },
                dark:{
                    success:{
                        background:"{surface.900}",
                        borderColor:"{green.500}",
                        color:"{surface.0}",
                        detailColor:"{surface.300}",
                        shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.40)"
                    },
                    error:{
                        background:"{surface.900}",
                        borderColor:"{red.500}",
                        color:"{surface.0}",
                        detailColor:"{surface.300}",
                        shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.40)"
                    },
                    warn:{
                        background:"{surface.900}",
                        borderColor:"{orange.500}",
                        color:"{surface.0}",
                        detailColor:"{surface.300}",
                        shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.40)"
                    },
                    info:{
                        background:"{surface.900}",
                        borderColor:"{blue.500}",
                        color:"{surface.0}",
                        detailColor:"{surface.300}",
                        shadow:"0 2px 15px 0 rgba(0, 0, 0, 0.40)"
                    }
                }
            }

        },
        closeButtonIcon:{
            size:"23px;"

        },
        message:{
            text:{
                 fontSize:"16px",
                 fontWeight:"400",
                 sm:{
                    fontSize:"14px"
                 }
            },
            colorScheme:{
                light:{
                    success:{
                        background:"F6ffed",
                        borderColor:"#b7eb8f",
                        color:"rgba(0,0,0,.88)",
                    },

                },
                dark:{
                    success:{
                        background:"{green.950}",
                        borderColor:"{green.700}",
                        color:"{surface.0}"
                    }
                }
            }

        },
        avatar:{
            root:{
                borderRadius:"4.8px"

            },
            xl:{
                width:"55px",
                height:"55px",
                fontSize:"16.25px",


            },
            colorScheme:{
                light:{
                    root:{
                        color:"{primary.600}",
                        background:"#f6ffed"
                    }
                },
                dark:{
                    root:{
                        color:"{primary.400}",
                        background:"{surface.800}"
                    }
                }
            }

        },
        splitter:{
root:{
    background:"none"
},
handle:{
    size:"24px",
    borderRadius:"6px"
},
colorScheme:{
    light:{
        root:{
            borderColor:"#fff"
        },
        handle:{
            background:"#000"
        }
    },
    dark:{
        root:{
            borderColor:"{surface.800}"
        },
        handle:{
            background:"{surface.0}"
        }
    }
}
        },
        stepper:{
    root:{

    },step:{
        gap:'8px',
        padding:'8px 12px'
    }
        },
        datatable: {
            colorScheme: {
                light: {
                    root: {
                        borderColor: "{surface.200}",


                    },
                    header: {
                        background: "#ccc",
                        color: "{slate.900}"
                    },
                    headerCell: {
                        background: "{gray.100}",
                        hoverBackground: "{gray.100}",
                        borderColor: "transparent",
                        hoverColor: "{slate.900}",
                        padding:"8px 12px",


                    },
                    bodyCell:{padding:"11px 12px",borderColor:"{neutral.200}"},
                    sortIcon: {
                        color: "#9e9ea2",
                        size: "10px"
                    },
                    row: {
                        color: "{slate.900}",
                        hoverBackground:"{gray.100}",

                    },
                    filter:{

                    }
                },
                dark:{
                    root: {
                        borderColor: "{surface.700}"
                    },
                    header: {
                        background: "{surface.800}",
                        color: "{surface.0}"
                    },
                    headerCell: {
                        background: "{surface.800}",
                        hoverBackground: "{surface.700}",
                        borderColor: "transparent",
                        color: "{surface.0}",
                        hoverColor: "{surface.0}",
                        padding:"8px 12px"
                    },
                    bodyCell:{
                        padding:"11px 12px",
                        borderColor:"{surface.700}"
                    },
                    sortIcon: {
                        color: "{surface.400}",
                        size: "10px"
                    },
                    row: {
                        background: "{surface.900}",
                        color: "{surface.0}",
                        hoverBackground:"{surface.800}"
                    }
                }
            }
        }
    }


}
)

export default Mytheme;
